module.exports = __webpack_public_path__ + "img/token_number.abf9b037.jpeg";